/**
 * ModernWash 세차 화면 공통 포맷 헬퍼.
 *
 * 어댑터 DTO 는 안정 계약이지만(docs/product/modernwash-legacy-adapter.md), 원천 전환
 * 과정에서 필드명이 일부 다를 수 있어 화면은 방어적으로 읽는다. `pick` 은 후보 키 중
 * 처음으로 값이 있는 것을 고르고, 없으면 폴백(기본 '-')을 반환한다. 어떤 필드가 비어도
 * 표가 깨지지 않고 '-' 로 조용히 표시된다.
 */

/** 후보 키들 중 처음으로 유효한 값을 고른다 (null/undefined/'' 는 건너뜀) */
export const pick = (obj, keys, fallback = undefined) => {
  if (!obj || typeof obj !== 'object') return fallback;
  for (const key of keys) {
    const value = obj[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return fallback;
};

export const formatNumber = (value) =>
  value === undefined || value === null || value === ''
    ? '-'
    : Number(value).toLocaleString('ko-KR');

export const formatWon = (value) =>
  value === undefined || value === null || value === ''
    ? '-'
    : `${Number(value).toLocaleString('ko-KR')}원`;

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('ko-KR', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

/** 짧은 시각 — 헤더의 "동기화 HH:mm" 같은 캡션용 */
export const formatTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

/** LPR 정확도 — 0~1 또는 0~100 어느 쪽으로 와도 백분율로 표시 */
export const formatConfidence = (value) => {
  if (value === undefined || value === null || value === '') return '-';
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  const percent = num <= 1 ? num * 100 : num;
  return `${Math.round(percent)}%`;
};

/** 소요 시간(초) → "m분 s초" / "s초" */
export const formatDuration = (seconds) => {
  if (seconds === undefined || seconds === null || seconds === '') return '-';
  const total = Number(seconds);
  if (Number.isNaN(total)) return '-';
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  if (mins <= 0) return `${secs}초`;
  return secs > 0 ? `${mins}분 ${secs}초` : `${mins}분`;
};
